import { defineMessages } from 'react-intl';

export default defineMessages({
    modalTitle: {
        id: 'portal.views.service-report-generator.ModalHeader',
        defaultMessage: 'Select a date range'
    },
    generateReportButton: {
        id: 'portal.views.service-report-generator.CSVLink.GenerateReportButton',
        defaultMessage: 'Print report'
    },
    cancelButton: {
        id: 'portal.views.service-report-generator.Button.Cancel',
        defaultMessage: 'Cancel'
    },
    maxElementsAlertTitle: {
        id: 'portal.views.service-report-generator.WarningAlert.Title',
        defaultMessage: 'Alert'
    },
    maxElementsAlertMessage: {
        id: 'portal.views.service-report-generator.WarningAlert.Message',
        defaultMessage: 'You have exceeded the maximum number of records allowed, please add more filters to your search'
    },
    noRecordsFoundAlertTitle: {
        id: 'portal.views.service-report-generator.NoRecordsAlert.Title',
        defaultMessage: 'No records found'
    },
    noRecordsFoundAlertMessage: {
        id: 'portal.views.service-report-generator.NoRecordsAlert.Message',
        defaultMessage: 'Select another date range'
    },
    errorCCCommunicationAlertTitle: {
        id: 'portal.views.service-report-generator.ErrorCCAlert.Title',
        defaultMessage: 'Error querying ClaimCenter'
    }
});
